import { useState } from 'react';
import { API_URL } from '@constants';
import { CreateAlertInput, CreateAlertSuccessResponse } from '@types';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/usr-alerts/create';

/**
 * Requests endpoint to create a new alert.
 */
export const useCreateAlert = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async (input: CreateAlertInput) => {
        setLoading(true);
        setSuccess(false);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(input),
            });

            const json = await response.json();

            if (!response.ok) {
                const errorMessage = json.message || json.error || 'Erro ao criar alerta';
                const error = new Error(errorMessage) as ApiError;
                error.statusCode = response.status;
                setError(errorMessage);
                throw error;
            }

            const data: CreateAlertSuccessResponse = json;
            setSuccess(true);
            setError(null);

            return data;
        } catch (err: any) {
            setSuccess(false);
            setError(err.message || 'Erro ao criar alerta');
            handleCommonErrors(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { request, loading, success, error };
};